var map = {
	"./BNB.png": 1358,
	"./BSC.png": 581,
	"./BUSD.png": 1359,
	"./DARK.png": 1360,
	"./EARTH-BUSD-LP.png": 1361,
	"./EARTH.png": 1362,
	"./EMIT.png": 582,
	"./ETH.png": 350,
	"./EUSDT.png": 1363,
	"./LIGHT.png": 1364,
	"./PFID.png": 1365,
	"./SERO.png": 351,
	"./TOUTPUT.png": 1366,
	"./TRON.png": 583,
	"./TRX.png": 1367,
	"./TUSDT.png": 1368,
	"./USDT.png": 1369,
	"./WATER-BUSD-LP.png": 1370,
	"./WATER.png": 1371,
	"./WBTC.png": 1372,
	"./WETH.png": 1373,
	"./bLIGHT.png": 1374,
	"./eth-icon.png": 1375,
	"./icon/NFT.png": 352,
	"./icon/NFT_selected.png": 584,
	"./icon/element.png": 585,
	"./icon/element_selected.png": 353,
	"./icon/epoch.png": 354,
	"./icon/epoch_selected.png": 586,
	"./icon/setting.png": 355,
	"./icon/setting_selected.png": 587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1357;